// Funciones globales

function oldestFirst(arr, sortBy) {
  arr.sort(function (a, b) {
    a = new Date(a.fields[sortBy]);
    b = new Date(b.fields[sortBy]);
    return a < b ? -1 : a > b ? 1 : 0;
  });
  return arr;
}

function newestFirst(arr, sortBy) {
  arr.sort(function (a, b) {
    a = new Date(a.fields[sortBy]);
    b = new Date(b.fields[sortBy]);
    return a > b ? -1 : a < b ? 1 : 0;
  });
  return arr;
}

function getEventsByMonth(fechasArr) {

  var eventos = {};
  var currentMonth = new Date().getMonth() + 1;
  var currentYear = new Date().getFullYear();

  var arrEventosPasados = [];
  var arrEventosFeb = [];
  var arrEventosMar = [];
  var arrEventosAbr = [];
  var arrEventosMayo = [];
  var arrEventosJun = [];
  var arrEventosJul = [];
  var arrEventosAgo = [];
  var arrEventosSep = [];
  var arrEventosOct = [];
  var arrEventosNov = [];
  var arrEventosBadDate = [];

  fechasArr.forEach(element => {
    
    var elemYear = parseInt(element.fields.fechaOrganizacional.substring(0, 4));
    var elemMonth = parseInt(element.fields.fechaOrganizacional.substring(5, 7));

    //año
    if (currentYear > elemYear || (currentYear == elemYear && currentMonth > elemMonth)) {
      arrEventosPasados.push(element);
    } else {

      switch (elemMonth) {
        case 2:
          arrEventosFeb.push(element);
          break;
        case 3:
          arrEventosMar.push(element);
          break;
        case 4:
          arrEventosAbr.push(element);
          break;
        case 5:
          arrEventosMayo.push(element);
          break;
        case 6:
          arrEventosJun.push(element);
          break;
        case 7:
          arrEventosJul.push(element);
          break;
        case 8:
          arrEventosAgo.push(element);
          break;
        case 9:
          arrEventosSep.push(element);
          break;
        case 10:
          arrEventosOct.push(element);
          break;
        case 11:
          arrEventosNov.push(element);
          break;
        default:
          arrEventosBadDate.push(element);
          break;
      }

    }
        
  });

  eventos = {
    "past" : arrEventosPasados,
    "feb" : arrEventosFeb,
    "mar" : arrEventosMar,
    "abr" : arrEventosAbr,
    "may" : arrEventosMayo,
    "jun" : arrEventosJun,
    "jul" : arrEventosJul,
    "ago" : arrEventosAgo,
    "sep" : arrEventosSep,
    "oct" : arrEventosOct,
    "nov" : arrEventosNov,
    "out" : arrEventosBadDate
  }

  return eventos;
}


export default {
  getEventsByMonth: getEventsByMonth,
  newestFirst : newestFirst,
  oldestFirst : oldestFirst
}
